import { render } from "./GroupCustomers.vue?vue&type=template&id=2e90833e&ts=true"
import script from "./GroupCustomers.vue?vue&type=script&lang=ts"
export * from "./GroupCustomers.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__